import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/inHouseRequest'

export const inHouseService = {
    search,
};


//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}